export default {
    pleaseInput: 'Please input',
    file: 'File',
    send: 'Send',
    loadAll: 'All loaded',
    expand: 'Expand',
    collapse: 'collapse',
    reply: 'Reply',
    comment: 'comment',
    selected: 'selected',
    person: 'person',
    sure: 'Ok',
    writeComment: 'Write comments',
    choose: 'Please select the person to @',
    imageTips1: 'Up to 8 files / pictures can be uploaded',
    uploadFail: 'Upload failure',
    imageTips2: '{text} files are not supported',
    moreThan: 'size over 5M',
    contentNoEmpty: 'Comment content cannot be empty',
    replyNoEmpty: 'Reply content cannot be empty',
    sureDeleteComment: 'Are you sure you want to delete this comment?',
    deleteCommentSuccess: 'Delete comment succeeded!',
    deleteCommentFailed: 'Failed to delete comment!',
    moreReplys: 'See {size} more replies >>',
    replyLoaded: 'All replies displayed',
};
